<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="text-container">Capturar Partidas</span>
  <button mat-icon-button (click)="closeDialogCapturarPartidas()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card style="background-color: whitesmoke;">
  <mat-card-content style="padding-top: 1rem;height: 100%;">
    <form [formGroup]="filterColumForm" class="contenedor" fxLayout.xs="column" fxLayoutGap="10px">
      <mat-form-field appearance="outline" [class.input-width-275]="classFlag" floatLabel="always">
        <mat-label> Filtro Específico </mat-label>
        <mat-select formControlName="filterDetails" (selectionChange)="cleanFilter()"
          matTooltip="Filtro por una columna de la tabla" matTooltipPosition="above">
          <mat-option value="0">Seleccione...</mat-option>
          <mat-option value="reference" matTooltip="Filtro por la columna Referencia"
            matTooltipPosition="right">Referencia</mat-option>
            <mat-option value="code" matTooltip="Filtro por la columna Código" matTooltipPosition="right">Código</mat-option>
          <mat-option value="description" matTooltip="Filtro por la columna Descripción"
            matTooltipPosition="right">Descripción</mat-option>
            <mat-option value="lineItemGrouping" matTooltip="Filtro por la columna Agrupación"
              matTooltipPosition="right">Agrupación</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" [ngClass]="classFlag ? 'input-width-275' : 'full-width-30vw'" floatLabel="always"
        matTooltip="Valor a filtrar por columna seleccionada" matTooltipPosition="above">
        <mat-label> Valor </mat-label>
        <input matInput placeholder="Valor a filtrar..." formControlName="descriptionFilter" (keyup)="resetPaginator($event)"
          #input2>
        <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('minlength')">Mínimo 3 caracteres.</mat-error>
        <mat-error *ngIf="filterColumForm.controls['descriptionFilter'].hasError('maxlength')">Máximo 100
          caracteres.</mat-error>
      </mat-form-field>
      <button mat-raised-button color="primary" type="button" (click)="applyFilterDetails()"
        [disabled]="disableButtonfilter">Filtrar</button>
        <div class="espacio-div-20" fxHide.lg fxHide.xl></div>
      <mat-form-field appearance="outline" class="full-width-8vw">
        <mat-label>Nro de Registros</mat-label>
        <input matInput disabled="true" [value]="nroRegistros">
      </mat-form-field>
    </form>
    <div class="mat-elevation-z4 div-ajusted contenedor-partidas">
      <table mat-table [dataSource]="dataSourceFilters" matSort matSortActive="reference" matSortDirection="asc"
        matSortDisableClear>
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
          <td mat-cell *matCellDef="let element" align="center"> {{element.reference}} </td>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Código </th>
          <td mat-cell *matCellDef="let element"> {{element.code}} </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Und. </th>
          <td mat-cell *matCellDef="let element" align="center"> {{element.unit}} </td>
        </ng-container>
        <ng-container matColumnDef="lowPerformance">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Rendimiento </th>
          <td mat-cell *matCellDef="let element"> {{element.normalPerformance | number:'1.6-6':'es'}} </td>
        </ng-container>
        <ng-container matColumnDef="lineItemGrouping">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Agrupación </th>
          <td mat-cell *matCellDef="let element"> {{element.lineItemGrouping}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-medium"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.selectedRow]="rowIsSelected(row.reference)"
          (click)="onRowClick(row.reference)"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="8">No hay data que filtrar</td>
        </tr>
      </table>
      <mat-paginator #paginator [length]="totalItemsPage" [pageSizeOptions]="[25, 50, 100]"
        showFirstLastButtons></mat-paginator>
    </div>
    <h3 style="margin-bottom: 0px !important; color: #01326D;">Partidas a capturar:</h3>
    <div class="mat-elevation-z4 div-ajusted contenedor-partidas">
      <table mat-table ngDefaultControl [(ngModel)]="listPartidasSeleccionadas" [dataSource]="listPartidasSeleccionadas">
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Referencia </th>
          <td mat-cell *matCellDef="let element" align="center"> {{element.reference}} </td>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Código </th>
          <td mat-cell *matCellDef="let element"> {{element.code}} </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Descripción </th>
          <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container matColumnDef="unit">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Und. </th>
          <td mat-cell *matCellDef="let element" align="center"> {{element.unit}} </td>
        </ng-container>
        <ng-container matColumnDef="lowPerformance">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Rendimiento </th>
          <td mat-cell *matCellDef="let element"> {{element.normalPerformance | number:'1.6-6':'es'}} </td>
        </ng-container>
        <ng-container matColumnDef="updateDate">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell-datalaing"> Fecha </th>
          <td mat-cell *matCellDef="let element"> {{element.updateDate | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsSelected" class="mat-header-medium"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSelected;"
          [class.selectedRow]="rowIsSelected(row.reference)" (click)="onRowClick(row.reference)"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="8">Seleccione de la lista las partidas a Capturar.</td>
        </tr>
      </table>
    </div>
    <mat-card-actions>
    <div class="mat-card-cvr" fxLayoutGap="20px">
      <button mat-raised-button color="warn" type="button" (click)="closeDialogCapturarPartidas()"
        class="align-center-middle">
        <span class="text-icon-space">Regresar</span>
        <mat-icon>restart_alt</mat-icon>
      </button>
      <div class="espacio-div-20" fxHide.sm fxHide.md fxHide.lg fxHide.xl></div>
      <button mat-raised-button color="primary" type="button" [disabled]="disableButtonAddItem"
        (click)="onSaveLineItemBudget()" class="align-center-middle">
        <span class="text-icon-space">Capturar Partidas</span>
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </mat-card-actions>
  </mat-card-content>
</mat-card>